export const TOKEN = 'session_id';
export const TOKEN_ACCESS = 'access_token';
export const TOKEN_EXPIRES_AT = 'token_expires_at';
